import { all, call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    GET_MY_NOTE_FRAIS_REQUESTS_REQUEST,
    CREATE_NOTE_FRAIS_REQUEST_REQUEST,
    CANCEL_NOTE_FRAIS_REQUEST_REQUEST,
    UPDATE_NOTE_FRAIS_REQUEST_REQUEST,
    GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST,
    MANAGER_NOTE_FRAIS_DECISION_REQUEST,
    GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST,
    ADMIN_NOTE_FRAIS_DECISION_REQUEST,
    MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST,
    GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST,
    GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST,
    GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST,
    GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST,
    setNoteDeFraisRequestLoading,
    getMyNoteDeFraisRequestsSuccess,
    getMyNoteDeFraisRequestsFail,
    createNoteDeFraisRequestSuccess,
    createNoteDeFraisRequestFail,
    cancelNoteDeFraisRequestSuccess,
    cancelNoteDeFraisRequestFail,
    updateNoteDeFraisRequestSuccess,
    updateNoteDeFraisRequestFail,
    getManagerNoteDeFraisInboxSuccess,
    getManagerNoteDeFraisInboxFail,
    managerNoteDeFraisDecisionSuccess,
    managerNoteDeFraisDecisionFail,
    getAdminNoteDeFraisInboxSuccess,
    getAdminNoteDeFraisInboxFail,
    adminNoteDeFraisDecisionSuccess,
    adminNoteDeFraisDecisionFail,
    marquerNoteDeFraisRembourseeSuccess,
    marquerNoteDeFraisRembourseeFail,
    getNoteDeFraisEnAttenteRemboursementSuccess,
    getNoteDeFraisEnAttenteRemboursementFail,
    getNoteDeFraisByOrdreMissionSuccess,
    getNoteDeFraisByOrdreMissionFail,
    getManagerNoteDeFraisHistorySuccess,
    getManagerNoteDeFraisHistoryFail,
    getAdminNoteDeFraisHistorySuccess,
    getAdminNoteDeFraisHistoryFail,
} from "../actions/noteDeFraisRequestActions";

import { API_BASE_URL, getRequest, postRequest, putRequest } from "../../../api";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;

    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);

    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

// ===================== WORKERS =====================

export function* getMyNoteDeFraisRequestsSaga(action) {
    const url = `${API_BASE_URL}/api/note-frais-requests/requests/mine`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyNoteDeFraisRequestsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes de note de frais");
        yield put(getMyNoteDeFraisRequestsFail(msg));
    } finally {
        if (!silent) yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* createNoteDeFraisRequestSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const payload = action.payload;

        console.log("📤 Payload reçu:", payload);

        // ✅ ÉTAPE 1 : Créer la demande (JSON simple)
        const details = {
            // Requis pour la validation du DTO unitaire ; le backend le remplace pour chaque ID du lot.
            noteDeFraisId: payload.noteDeFraisIds?.[0] || payload.noteDeFraisId,
            ordreMissionId: payload.ordreMissionId || null,
            dateDepense: payload.dateDepense,
            montantDepense: payload.montantDepense,
            avance: payload.avance,
            description: payload.description,
            urgent: payload.urgent || false,
            centreCouts: payload.centreCouts || null,
        };
        const isGrouped = Array.isArray(payload.items) && payload.items.length > 0;
        const isBatch = !isGrouped && Array.isArray(payload.noteDeFraisIds) && payload.noteDeFraisIds.length > 1;
        const url = `${API_BASE_URL}/api/note-frais-requests/requests${isGrouped ? "/grouped" : isBatch ? "/batch" : ""}`;
        const requestData = isGrouped
            ? { ordreMissionId: payload.ordreMissionId || null, centreCouts: payload.centreCouts || null, urgent: payload.urgent || false, avance: payload.avance, items: payload.items }
            : isBatch
                ? { noteDeFraisIds: payload.noteDeFraisIds, details }
                : { ...details, noteDeFraisId: payload.noteDeFraisIds?.[0] || payload.noteDeFraisId };

        console.log("📦 Données de la demande:", requestData);

        const resp = yield call(postRequest, {
            url,
            token,
            data: requestData,
            headers: { uid },
        });

        console.log("✅ Demande créée:", resp.data);

        // ✅ ÉTAPE 2 : Si des fichiers existent, les uploader séparément
        if (payload.justificatifs && Array.isArray(payload.justificatifs) && payload.justificatifs.length > 0) {
            const validFiles = payload.justificatifs.filter(file =>
                file instanceof File && file.size > 0
            );

            if (validFiles.length > 0) {
                console.log("📎 Upload de", validFiles.length, "fichiers...");

                const createdRequests = Array.isArray(resp.data) ? resp.data : [resp.data];
                for (const request of createdRequests) {
                    const formData = new FormData();
                    validFiles.forEach(file => formData.append("files", file));
                    yield call(postRequest, {
                        url: `${API_BASE_URL}/api/note-frais-requests/requests/${request.id}/justificatifs`,
                        token,
                        data: formData,
                        headers: { uid },
                    });
                }

                console.log("✅ Fichiers uploadés");
            }
        }

        if (payload.justificatifAvance instanceof File && payload.justificatifAvance.size > 0) {
            const createdRequest = Array.isArray(resp.data) ? resp.data[0] : resp.data;
            const formData = new FormData();
            formData.append("file", payload.justificatifAvance);
            yield call(postRequest, {
                url: `${API_BASE_URL}/api/note-frais-requests/requests/${createdRequest.id}/justificatif-avance`,
                token,
                data: formData,
                headers: { uid },
            });
        }

        yield put(createNoteDeFraisRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Note de frais envoyée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });

        // Recharger les demandes
        yield put({ type: GET_MY_NOTE_FRAIS_REQUESTS_REQUEST });

    } catch (error) {
        console.error("❌ Erreur création demande:", error);
        console.error("❌ Response:", error?.response?.data);
        console.error("❌ Status:", error?.response?.status);

        const msg = extractErrorMessage(error, "Erreur création note de frais");
        yield put(createNoteDeFraisRequestFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* cancelNoteDeFraisRequestSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { id } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/requests/${id}/cancel`;

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: {}, headers: { uid } });
        yield put(cancelNoteDeFraisRequestSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Note de frais annulée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });
        yield put({ type: GET_MY_NOTE_FRAIS_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur annulation note de frais");
        yield put(cancelNoteDeFraisRequestFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* updateNoteDeFraisRequestSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { id, justificatifAvance, ...data } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/requests/${id}`;

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        if (justificatifAvance instanceof File && justificatifAvance.size > 0) {
            const formData = new FormData();
            formData.append("file", justificatifAvance);
            yield call(postRequest, {
                url: `${API_BASE_URL}/api/note-frais-requests/requests/${id}/justificatif-avance`,
                token,
                data: formData,
                headers: { uid },
            });
        }
        yield put(updateNoteDeFraisRequestSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Note de frais modifiée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });
        yield put({ type: GET_MY_NOTE_FRAIS_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur modification note de frais");
        yield put(updateNoteDeFraisRequestFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getManagerNoteDeFraisInboxSaga(action) {
    const url = `${API_BASE_URL}/api/note-frais-requests/manager/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerNoteDeFraisInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox manager");
        yield put(getManagerNoteDeFraisInboxFail(msg));
    } finally {
        if (!silent) yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* managerNoteDeFraisDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, decision, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/manager/requests/${id}/decision`;

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { decision, comment },
            headers: { uid },
        });

        yield put(managerNoteDeFraisDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(managerNoteDeFraisDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getAdminNoteDeFraisInboxSaga(action) {
    const url = `${API_BASE_URL}/api/note-frais-requests/admin/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminNoteDeFraisInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox RH");
        yield put(getAdminNoteDeFraisInboxFail(msg));
    } finally {
        if (!silent) yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* adminNoteDeFraisDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, decision, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/admin/requests/${id}/decision`;

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { decision, comment },
            headers: { uid },
        });

        yield put(adminNoteDeFraisDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision RH envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision RH");
        yield put(adminNoteDeFraisDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* marquerNoteDeFraisRembourseeSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, referencePaiement } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/admin/requests/${id}/rembourser`;

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {},
            headers: { uid },
            params: { referencePaiement },
        });

        yield put(marquerNoteDeFraisRembourseeSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Note de frais marquée comme remboursée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur marquage remboursement");
        yield put(marquerNoteDeFraisRembourseeFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getNoteDeFraisEnAttenteRemboursementSaga() {
    const url = `${API_BASE_URL}/api/note-frais-requests/admin/en-attente-remboursement`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getNoteDeFraisEnAttenteRemboursementSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement notes en attente");
        yield put(getNoteDeFraisEnAttenteRemboursementFail(msg));
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getNoteDeFraisByOrdreMissionSaga(action) {
    const { ordreMissionId } = action.payload || {};
    const url = `${API_BASE_URL}/api/note-frais-requests/requests/ordre-mission/${ordreMissionId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getNoteDeFraisByOrdreMissionSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement notes par ordre de mission");
        yield put(getNoteDeFraisByOrdreMissionFail(msg));
    } finally {
        yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getManagerNoteDeFraisHistorySaga(action) {
    const url = `${API_BASE_URL}/api/note-frais-requests/manager/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerNoteDeFraisHistorySuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique manager");
        yield put(getManagerNoteDeFraisHistoryFail(msg));
    } finally {
        if (!silent) yield put(setNoteDeFraisRequestLoading(false));
    }
}

export function* getAdminNoteDeFraisHistorySaga(action) {
    const url = `${API_BASE_URL}/api/note-frais-requests/admin/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setNoteDeFraisRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminNoteDeFraisHistorySuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique admin");
        yield put(getAdminNoteDeFraisHistoryFail(msg));
    } finally {
        if (!silent) yield put(setNoteDeFraisRequestLoading(false));
    }
}
